import React, { useState, useEffect } from 'react';
import Basic from '../Components/Basic/Basic';
import { get_user_accounts, get_inv_adv_menu, participate_inv_adv_menu } from '../services/common';
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';

const InvAdvMenu = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [userName, setUserName] = useState('');
  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [docs, setDocs] = useState([]);
  const [form, setForm] = useState({
    e_name: '',
    e_phone_no: '',
    e_email: '',
    e_dob: '',
    curdate: '',
    amount: '',
    current_date: ''
  });
  const [invMenu, setInvMenu] = useState({});
  const [confirm, setConfirm] = useState(0);
  const [totalAcBalance, setTotalAcBalance] = useState(0);
  const [isInvested, setIsInvested] = useState(0);
  const [localStorageData, setLocalStorageData] = useState({});
  const [dashboard, setDashboard] = useState({});
  const [alerts, setAlerts] = useState([]);
  const [errors, setErrors] = useState([]);
  const [invId, setInvId] = useState(0);
  const [errorFlag, setErrorFlag] = useState(0);
  const [confirmError, setConfirmError] = useState('');
  const [investmentCurrency, setInvestmentCurrency] = useState('USD');
  const [currentDate, setCurrentDate] = useState(moment(new Date()).format("DD/MM/YYYY"));
  const [isSubmitting, setIsSubmitting] = useState(false);

  const STORAGE_KEY = "caprock-local";

  useEffect(() => {
    setLocalStorageData(localStorage.getItem("systemToken")); 
    // const js = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    // if (typeof js !== 'undefined' && typeof js['access-token'] !== 'undefined') {
    //   console.log("here1",js);
    //     setLocalStorageData(js);
    // } else {
    //   localStorage.removeItem(STORAGE_KEY);
    //   navigate('/sign-in');
    // }
    document.title = "Investment advisor menu || Caprock Merchant Platform";
    localStorage.setItem('active_page', 'inv_menu');
  }, [navigate]);

  useEffect(() => {
    // console.log(localStorageData);
    // if (localStorageData['access-token']) {
        console.log("here");
      setUserName('');
      getUserAccounts();
      getInvestmentAdvisorData(id);
    // }
  }, [localStorageData, id]);

  const getUserAccounts = async () => {
    try {
      const systemToken = localStorage.getItem("systemToken");
      console.log("Getting user accounts with token:", systemToken);
      const response = await get_user_accounts(systemToken, 1);
      console.log("User accounts response:", response);
      
      if (response.success === 200) {
        const cAcs = response.accounts;
        console.log("Accounts data:", cAcs);
        setTotalAcBalance(response.t_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

        const processedAccounts = cAcs.map(ac => {
          const ser = [{
            name: 'Balance',
            data: ac.ac_chart
          }];
          const chartO = {
            chart: {
              height: 200,
              type: 'area',
              toolbar: {
                show: false
              }
            },
            labels: {
              show: false,
            },
            grid: {
              show: false,
            },
            stroke: {
              curve: 'smooth',
              width: 2
            },
            xaxis: {
              categories: moment.monthsShort(),
              labels: {
                show: false
              },
              lines: {
                show: false
              }
            },
            yaxis: {
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false,
              },
              labels: {
                show: false
              }
            },
            colors: [ac.ac_color],
            dataLabels: {
              enabled: false
            }
          };

          return {
            ...ac,
            series: ser,
            chartOptions: chartO
          };
        });

        console.log("Processed accounts:", processedAccounts);
        setCustomerAccounts(processedAccounts);
      } else {
        console.log("API response not successful:", response);
      }
    } catch (error) {
      console.error('Error fetching user accounts:', error);
    }
  };

  const getInvestmentAdvisorData = async (id) => {
    try {
      setInvId(id);
      const systemToken = localStorage.getItem("systemToken");
      const response = await get_inv_adv_menu(systemToken, id);
      if (response.success === 200) {
        setInvMenu(response.inv_adv_menu);
        setDocs(response.documents);
        setInvestmentCurrency(response.inv_adv_menu.currency);
        document.title = `${response.inv_adv_menu.inv_name} || Caprock Merchant Platform`;
        
        if (response.investment !== 0) {
          setIsInvested(response.investment);
        }
      }
      if (response.inv_adv_menu.length === 0) {
        navigate('/');
      }
    } catch (error) {
      console.error('Error fetching investment advisor data:', error);
    }
  };

  const participateInvAdvMenu = async (id) => {
    try {
      const response = await participate_inv_adv_menu(localStorageData['access-token'], id);
      if (response.success === 200) {
        // Show success toast
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else {
        // Show error toast
      }
    } catch (error) {
      console.error('Error participating in menu:', error);
    }
  };

  const handleFormChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (phone) => {
    return phone.length >= 7 && phone.length <= 12 && !isNaN(phone);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    
    setForm(prev => ({
      ...prev,
      current_date: moment(new Date()).format("YYYY-MM-DD")
    }));

    setIsSubmitting(true);
    setErrors([]);
    setErrorFlag(0);

    // Validation
    const newErrors = [];
    
    if (!form.e_name) newErrors.push('Name is required');
    if (!form.e_email) newErrors.push('Email is required');
    if (!form.e_phone_no) newErrors.push('Phone number is required');
    if (!form.e_dob) newErrors.push('Date of birth is required');
    if (!form.amount) newErrors.push('Amount is required');
    
    if (form.e_email && !validateEmail(form.e_email)) {
      newErrors.push('Please enter a valid email address');
    }
    
    if (form.e_phone_no && !validatePhone(form.e_phone_no)) {
      newErrors.push('Please enter a valid phone number');
    }

    if (confirm === 0) {
      setConfirmError("Please agree to condition.");
      setErrorFlag(1);
    } else {
      setConfirmError("");
    }

    if (newErrors.length > 0 || errorFlag === 1) {
      setErrors(newErrors);
      setIsSubmitting(false);
      return;
    }

    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => {
        formData.append(key, form[key]);
      });
      formData.append('user_token', localStorageData['access-token']);
      formData.append('inv_id', invId);

      const response = await fetch(`${process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au'}/customer-investment-application`, {
        method: 'POST',
        body: formData,
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      });

      const result = await response.json();
      
      if (result.success === 200) {
        // Show success toast
        setTimeout(() => {
          navigate('/sign-in');
        }, 2500);
      } else {
        // Show error toast
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Basic />
      
    
      {/* Main Container */}
      <div className="flex min-h-screen">
        
        {/* Left Column (Main Content) */}
        <div className="flex-[3] p-5">
          <section className="section">
            <div className="flex">
              <div className="w-3/4 text-left flex items-center">
                <img 
                  className="mr-4" 
                  src="https://map.admin.caprock.com.au/inlancer-admin/images/dashboard.svg" 
                  style={{ height: '18px' }} 
                  alt="Dashboard"
                />
                <h5 className="text-base text-gray-600">
                  <b>
                    {invMenu.inv_name || 'Loading...'} {typeof invMenu.inv_investment_type !== 'undefined' ? ' - ' + invMenu.inv_investment_type : ''}
                  </b>
                </h5>
              </div>
              {isInvested !== 0 && (
                <div className="w-1/4 text-right flex items-center">
                  <h5 className="text-sm font-light text-gray-500 tracking-wider">
                    <b className="border border-gray-300 px-3 py-1">Invested {isInvested} time</b>
                  </h5>
                </div>
              )}
            </div>

            <div className="tab-content w-full">
              <div className="tab-pane fade show active">
                <div className="flex">
                  <div className="w-full">
                    
                    {/* Basic Info + Docs */}
                    <div className="flex gap-4 mb-4">
                      {/* Basic Information */}
                      <div className="flex-[2] bg-white rounded-lg p-4 shadow-sm">
                        <p className="flex justify-between items-center mb-4">
                          <span className="text-sm font-medium text-gray-700">
                            Basic Information
                          </span>
                          <span 
                            className={`text-xs px-2 py-1 rounded ${
                              invMenu.inv_status === 'Active' 
                                ? 'text-green-600 bg-green-100' 
                                : 'text-red-600 bg-red-100'
                            }`}
                          >
                            {invMenu.inv_status || 'Loading...'}
                          </span>
                        </p>

                        <div className="text-sm text-gray-600">
                          <div className="w-full">
                            <div className="flex mb-2">
                              <div className="w-5/12 text-sm text-gray-600">
                                Ref Code :
                              </div>
                              <div className="w-7/12 text-sm text-gray-600">
                                <span className="font-bold text-gray-600 text-sm">
                                  {invMenu.inv_ref_code || 'Loading...'}
                                </span>
                              </div>
                            </div>

                            <div className="flex mb-2">
                              <div className="w-5/12 text-sm text-gray-600">
                                Name :
                              </div>
                              <div className="w-7/12 text-sm text-gray-600">
                                <span className="font-bold text-gray-600 text-sm">
                                  {invMenu.inv_name || 'Loading...'}
                                </span>
                              </div>
                            </div>

                            <div className="flex mb-2">
                              <div className="w-5/12">
                                Type :
                              </div>
                              <div className="w-7/12">
                                <span className="font-bold text-gray-600 text-sm">
                                  {invMenu.inv_type || 'Loading...'}
                                </span>
                              </div>
                            </div>

                            <div className="flex mb-2">
                              <div className="w-5/12 text-sm text-gray-600">
                                Location:
                              </div>
                              <div className="w-7/12 text-sm text-gray-600">
                                <span className="font-bold text-gray-600 text-sm">
                                  {invMenu.location || 'Loading...'}
                                </span>
                              </div>
                            </div>

                            <div className="flex mb-2">
                              <div className="w-5/12 text-sm text-gray-600">
                                Minimum Investment Amount :
                              </div>
                              <div className="w-7/12 text-sm text-gray-600">
                                <span className="font-bold text-gray-600 text-xs">
                                  {invMenu.inv_amount || 'Loading...'}
                                </span>
                                <span className="text-gray-600 text-xs">
                                  (Currency - {invMenu.currency || 'Loading...'})
                                </span>
                              </div>
                            </div>

                            {invMenu.inv_interest_rate && (
                              <div className="flex mb-2">
                                <div className="w-5/12 text-sm text-gray-600">
                                  Interest Rate :
                                </div>
                                <div className="w-7/12 text-sm text-gray-600">
                                  <span className="font-bold text-gray-600 text-xs">
                                    {invMenu.inv_interest_rate} %
                                  </span>
                                </div>
                              </div>
                            )}

                            {invMenu.inv_coupon && (
                              <div className="flex mb-2">
                                <div className="w-5/12 text-sm text-gray-600">
                                  Coupon :
                                </div>
                                <div className="w-7/12 text-sm text-gray-600">
                                  <span className="font-bold text-gray-600 text-xs">
                                    {invMenu.inv_coupon}
                                  </span>
                                </div>
                              </div>
                            )}

                            {invMenu.inv_term_type && invMenu.inv_term && (
                              <div className="flex mb-2">
                                <div className="w-5/12 text-sm text-gray-600">
                                  Term :
                                </div>
                                <div className="w-7/12 text-sm text-gray-600">
                                  <span className="font-bold text-gray-600 text-xs">
                                    {invMenu.inv_term} {invMenu.inv_term_type}
                                  </span>
                                </div>
                              </div>
                            )}

                            {invMenu.inv_subscription && (
                              <div className="flex mb-2">
                                <div className="w-5/12 text-sm text-gray-600">
                                  Subscription :
                                </div>
                                <div className="w-7/12 text-sm text-gray-600">
                                  <span className="font-bold text-gray-600 text-xs">
                                    {invMenu.inv_subscription} {invMenu.inv_subscription_other ? '- ' + invMenu.inv_subscription_other : ''}
                                  </span>
                                </div>
                              </div>
                            )}

                            {invMenu.inv_issue_price && (
                              <div className="flex mb-2">
                                <div className="w-5/12 text-sm text-gray-600">
                                  Issue Price :
                                </div>
                                <div className="w-7/12 text-sm text-gray-600">
                                  <span className="font-bold text-gray-600 text-xs">
                                    {invMenu.inv_issue_price}
                                  </span>
                                </div>
                              </div>
                            )}

                            {invMenu.inv_rank && (
                              <div className="flex mb-2">
                                <div className="w-5/12 text-sm text-gray-600">
                                  Rank :
                                </div>
                                <div className="w-7/12 text-sm text-gray-600">
                                  <span className="font-bold text-gray-600 text-xs">
                                    {invMenu.inv_rank}
                                  </span>
                                </div>
                              </div>
                            )}

                            <div className="flex mb-2">
                              <div className="w-5/12 text-sm text-gray-600">
                                Asset Type :
                              </div>
                              <div className="w-7/12 text-sm text-gray-600">
                                <span className="font-bold text-gray-600 text-xs">
                                  {invMenu.inv_asset_type || 'Loading...'}
                                </span>
                              </div>
                            </div>

                            <div className="flex mb-2">
                              <div className="w-5/12 text-sm text-gray-600">
                                Asset Sector
                              </div>
                              <div className="w-7/12 text-sm text-gray-600">
                                <span className="font-bold text-gray-600 text-xs">
                                  {invMenu.inv_asset_sector || 'Loading...'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Documents */}
                      <div className="flex-[1] bg-white rounded-lg p-4 shadow-sm">
                        <p className="text-sm font-medium text-gray-700 mb-4">
                          Documents
                        </p>
                        {docs.length > 0 ? (
                          docs.map((doc) => (
                            <p key={doc.doc_id} className="ml-2 pb-1">
                              <span className="text-sm text-gray-500">
                                {doc.doc_name}
                              </span>
                              <a href={doc.doc_url} target="_blank" rel="noopener noreferrer">
                                <span 
                                  title={`Download ${doc.doc_name}`} 
                                  className="cursor-pointer text-sm text-gray-500 float-right"
                                >
                                  <svg style={{ height: '25px', width: '25px' }} viewBox="0 0 752 752">
                                    <path fill="grey" d="m552.19 261.61c-13.464-77.229-80.529-135.11-160.89-135.11-64.695 0-122.75 38.124-148.96 96.303-1.6582-0.0793-3.3005-0.11901-4.935-0.11901-54.395 0-101.6 34.545-118.49 85.298-66.71 21.905-112.37 84.171-112.37 155.18 0 90.171 73.357 163.52 163.52 163.52h394.38c100.78 0 182.76-81.981 182.76-182.76 0-104.84-88.648-189.85-195.01-182.32zm-160.89 297.74-125.04-134.66h76.952v-86.568h96.191v86.568h76.952z" strokeWidth="2.0311" />
                                  </svg>
                                </span>
                              </a>
                            </p>
                          ))
                        ) : (
                          <p className="ml-2 pb-1">
                            <span className="text-sm text-gray-500">
                              No Document Found
                            </span>
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Terms & Conditions */}
                    <div className="bg-white rounded-lg p-5 mb-4 shadow-sm">
                      <p className="text-sm font-medium text-gray-700 mb-2">
                        Terms & Conditions / Descriptions
                      </p>
                      <p className="text-gray-500 whitespace-pre-wrap">{invMenu.inv_terms || 'Loading terms...'}</p>
                    </div>

                    {/* Investment Application */}
                    <div className="bg-white rounded-lg p-5 shadow-sm">
                      <div className="login-card bg-white p-4 rounded">
                        <div className="login-body">
                          <div className="form-group mt-1 mb-0">
                            <h5 className="text-sm font-medium text-gray-700 mb-0">
                              Investment Application
                              <label className="label float-right">Date : {currentDate}</label>
                            </h5>
                            <br />
                          </div>

                          <form onSubmit={submitForm}>
                            <div className="flex flex-wrap -mx-2">
                              <div className="w-1/2 px-2 mb-4">
                                <input
                                  type="text"
                                  placeholder="Amount you would like to invest"
                                  value={form.amount}
                                  onChange={(e) => handleFormChange('amount', e.target.value)}
                                  className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none focus:border-blue-500"
                                  required
                                />
                              </div>
                              <div className="w-1/2 px-2 mb-4">
                                <input
                                  type="text"
                                  placeholder="Your Name"
                                  value={form.e_name}
                                  onChange={(e) => handleFormChange('e_name', e.target.value)}
                                  className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none focus:border-blue-500"
                                  required
                                />
                              </div>
                              <div className="w-1/2 px-2 mb-4">
                                <input
                                  type="email"
                                  placeholder="Your Email Address"
                                  value={form.e_email}
                                  onChange={(e) => handleFormChange('e_email', e.target.value)}
                                  className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none focus:border-blue-500"
                                  required
                                />
                              </div>
                              <div className="w-1/2 px-2 mb-4">
                                <input
                                  type="tel"
                                  placeholder="Your Phone Number"
                                  value={form.e_phone_no}
                                  onChange={(e) => handleFormChange('e_phone_no', e.target.value)}
                                  className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none focus:border-blue-500"
                                  required
                                />
                              </div>
                              <div className="w-1/2 px-2 mb-4">
                                <input
                                  type="date"
                                  placeholder="Date of Birth"
                                  value={form.e_dob}
                                  onChange={(e) => handleFormChange('e_dob', e.target.value)}
                                  className="w-full border-b border-gray-300 py-2 px-3 focus:outline-none focus:border-blue-500"
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-group mt-1 mb-0">
                              <div className="flex items-center">
                                <button
                                  type="button"
                                  onClick={() => setConfirm(confirm === 1 ? 0 : 1)}
                                  className="mr-2"
                                >
                                  {confirm === 1 ? (
                                    <svg style={{ height: '15px', width: '15px', margin: '5px' }} viewBox="0 0 100 100">
                                      <path d="m2.5789 200.25h94.389v94.389h-94.389z" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="2.7351" />
                                      <path d="m64.04 52.74 6.31 6.9806 13.98-20.311" fill="none" stroke="#000" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="5" />
                                    </svg>
                                  ) : (
                                    <svg style={{ height: '15px', width: '15px', margin: '5px' }} viewBox="0 0 100 100">
                                      <path d="m2.5789 200.25h94.389v94.389h-94.389z" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="2.7351" />
                                    </svg>
                                  )}
                                </button>
                                <label className="text-sm text-gray-600">
                                  I confirm I have read the Information Memorandum and agree to the Terms & Conditions
                                </label>
                              </div>
                              {confirmError && (
                                <small className="text-red-500 ml-2">{confirmError}</small>
                              )}
                            </div>

                            {errors.length > 0 && (
                              <div className="mb-4">
                                {errors.map((error, index) => (
                                  <p key={index} className="text-red-500 text-sm">{error}</p>
                                ))}
                              </div>
                            )}

                            <div className="flex justify-center mx-0 mb-1 mt-0">
                              <div className="w-full px-1">
                                <button
                                  type="submit"
                                  disabled={isSubmitting}
                                  className="w-full bg-green-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                  {isSubmitting ? 'Processing...' : 'Invest Now'}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

      {/* Right Column (Sidebar) */}
      <div className="flex-[1] bg-gray-100 p-5 border-l border-gray-200">
        <div className="flex flex-col gap-4">
          {customerAccounts.length === 0 ? (
            <div className="bg-white rounded-lg p-4 shadow-sm">
              <p className="text-sm text-gray-500">Loading accounts...</p>
            </div>
          ) : (
            customerAccounts.map(ac => (
              <div key={ac.userac_id} className="bg-white rounded-lg p-4 shadow-sm">
                <p className="text-xs text-gray-600">{ac.ac_name}</p>
                <p className="text-lg font-bold text-gray-800">
                  ${ac.default_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
              </div>
            ))
          )}

          <div className="bg-white rounded-lg p-4">
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Total Portfolio</span>
              <span className="text-sm font-bold">${totalAcBalance}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
};

export default InvAdvMenu;
